/* eslint-disable */
/* eslint-disable prefer-template */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import {
  fetchUserHistory,
  fetchUserPropertyNames,
  updateUserHistoryFilter,
  updateUserHistorySearchString,
} from '../actions';
import {
  selectMMT,
  selectUserFilterHistoryLogs,
  selectUserPropertyNames,
} from '../selectors';
import _ from 'lodash';
import { FiltersCloud } from './UserFiltersCloud';
import cn from 'classnames';

import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './SearchUserHistoryLogs.module.css';
import { Search } from '../../../components/Icon';
import { selectWork } from '../../Api/selectors';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import { REQUEST_USER_PROPERTY_NAMES } from '../constants';

const Container = styled.div`
  & * .Dropdown-root {
    width: 100%;
  }

  .button {
    width: auto;
  }

  .fw-light {
    font-size: 12px !important;
    font-weight: 400 !important;
    font-family: Poppins, sans-serif !important;
    padding-left: 10px !important;
    color: #808080 !important;
  }
  @media (max-width: 767.98px) {
    .fw-light {
      font-size: 16px !important;
    }
  }

  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const STATE = {
  showAllFilters: false,
  filterToReset: null,
  isFilterMenuOpen: false,
  search: '',
  properties: [],
};

/* eslint-disable react/prefer-stateless-function */
class UserHistoryLogsSearchComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.fetchProperties();
  }

  get optionsPropertyNames() {
    return this.props.userPropertyNames?.map(p => ({ value: p?.name, label: p?.name }));

  }

  doSearch = () => {
    const text = this.props.filter?.text;
    const properties = this.props.filter?.properties;
    this.props.applyFilters(text, properties);
  };

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.doSearch();
    }
  };

  reset() {
    this.props.updateSearchString('');
    this.props.updateFilter([]);
    this.props.applyFilters();
  }

  render() {
    // if (!this.props.filter) return null;

    return (
      <Container>
        <div className="container-fluid p-0">
          <div className="container-fluid ps-0 pe-0 pt-3 pb-0 bg-white">
            <div className="row p-0 m-0 align-items-center">
              <div className="col-7 col-sm-8 mb-3 col-md-12 col-lg-12 col-xl-12 col-xxl-6">
                <div className="d-flex">
                  <input
                    type="text"
                    className={`form-control fw-light ${styles.Input}`}
                    name="search"
                    value={this.props.filter?.text}
                    placeholder={`${this.lblStr('zoeken')}...`}
                    onChange={evt => {
                      this.props.updateSearchString(evt.target.value);
                    }}
                    onKeyPress={this.handleKeyPress}
                  />
                  <button
                    className={`btn btn-outline-secondary ${styles.Button}`}
                    type="button"
                    onClick={this.doSearch.bind(this)}
                  >
                    <Search />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid ps-0 pe-0 pt-3 pb-0 bg-white">
            <div className="row p-0 m-0 align-items-center">
              <div className="col-7 col-sm-8 mb-3 col-md-12 col-lg-12 col-xl-12 col-xxl-6">
                <SearchSelect
                  isMulti
                  isLoading={this.props.workProperties}
                  options={this.optionsPropertyNames}
                  value={this.props.filter?.properties}
                  onChange={e => {
                    this.props.updateFilter(e);
                  }}
                />
              </div>
            </div>
          </div>

          <div style={{ backgroundColor: 'white' }} className="container-fluid pt-0">
            <div className="row" style={{ width: 'auto' }}>
              <div className={cn('col-12 mb-3 col-sm-12 mb-3 col-lg-5 mb-3 col-xl-6 mb-3 text-end', styles.container)}>
                <div className="mt-2 d-flex gap-2">
                  <ButtonComponent style={'ButtonSoftEdit'} onClick={() => this.doSearch()}>
                    {this.lblStr('vehicle.filter.apply')}
                  </ButtonComponent>
                  <ButtonComponent style={'ButtonSoftDelete'} onClick={() => this.reset()}>
                    {this.lblStr('invoice.filter.clearAll')}
                  </ButtonComponent>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

UserHistoryLogsSearchComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    userPropertyNames: selectUserPropertyNames(),
    workProperties: selectWork(REQUEST_USER_PROPERTY_NAMES),
    filter: selectUserFilterHistoryLogs(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchProperties() {
      dispatch(fetchUserPropertyNames());
    },
    updateFilter(properties) {
      dispatch(updateUserHistoryFilter(properties));
    },
    updateSearchString(text) {
      dispatch(updateUserHistorySearchString(text));
    },
    applyFilters(text, properties, callback) {
      dispatch(fetchUserHistory(ownProps.user.id, text, properties, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserHistoryLogsSearch = compose(withConnect, withRouter, injectIntl)(UserHistoryLogsSearchComp);
